import React from "react";
import { Text } from "@gcs/design-system/react";

import Button from "components/common/Button/Button";

import { ReactComponent as ExternalLinkIcon } from "assets/svgs/external-link-icon.svg";

import * as S from "./SectionDataProtection.Style";

const SectionDataProtection = () => {
  return (
    <S.SectionDataProtectionContainer className="container">
      <S.SectionDataProtectionTitle>
        Conformidade e Proteção de Dados
      </S.SectionDataProtectionTitle>

      <S.SectionDataProtectionContent>
        <S.SectionDataProtectionBlock>
          <Text>
            A gestão de Conformidade faz parte da Diretoria de Riscos e
            Controles Internos, liderada pelo diretor Jorge Alves. Atua para que
            nossas ações estejam alinhadas às leis, regulamentações e normas
            internas, promovendo ética, integridade e transparência.
          </Text>
          <Text>
            Em parceria com as demais áreas que compõem a nossa estrutura, apoia
            a prevenção e a mitigação de riscos, bem como o fortalecimento da
            governança corporativa, contribuindo para a sustentabilidade e a
            perenidade dos negócios.
          </Text>
          <Text>
            Atualmente, possui uma equipe multidisciplinar com 15 colaboradores,
            distribuídos em duas frentes de atuação:
          </Text>
          <Text>
            1 - Conformidade e PLD/FT <br /> 2 - Privacidade, Proteção de Dados
            e Regulatório
          </Text>

          <Button
            as="a"
            href="https://static.cnpbrasil.com.br/AreaAberta/Relatorios/Conformidade/Organograma_Conformidade_2026.pdf"
            size="lg"
            target="_blank"
          >
            Conheça quem faz parte da área de Conformidade <ExternalLinkIcon />
          </Button>

          <Text>
            A área também desempenha um papel essencial na promoção da
            Privacidade e Proteção de Dados, garantindo a segurança das
            informações de todas as pessoas que se relacionam com a gente:
            clientes, parceiros e colaboradores.
          </Text>

          <Text>
            Quer conferir? Então acesse o nosso Portal de Privacidade pelo link
            a seguir.
          </Text>

          <Button
            as="a"
            size="lg"
            target="_blank"
            href="https://csh.my.site.com/portalprivacidade/s/"
          >
            Portal de privacidade <ExternalLinkIcon />
          </Button>
        </S.SectionDataProtectionBlock>
      </S.SectionDataProtectionContent>
    </S.SectionDataProtectionContainer>
  );
};

export default SectionDataProtection;
